import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX} from "react";

interface IconProps {
	className?: string;
	icon: string;
	title?: string;
}

export default function Icon({icon, title, className}: IconProps): JSX.Element {
	if (isNullOrEmpty(icon)) {
		return <></>;
	}

	if (isNullOrEmpty(title)) {
		return <span className={className} aria-hidden={true} data-icon={icon}></span>;
	}

	return <span className={className} title={title} aria-label={title} data-icon={icon}></span>;
}
